import { BaseError } from 'make-error';

export class PlatformError extends BaseError {
    constructor(message?: string) {
        super(message ?? 'An unknown error occurred');
    }

    // eslint-disable-next-line @typescript-eslint/naming-convention
    toJSON() {
        return {
            message: this.message,
            name: this.name,
            stack: this.stack,
        };
    }
}

export class NotImplementedError extends PlatformError {
    constructor(message?: string) {
        super(message ?? 'Feature is not implemented by this platform.');
    }
}
